import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService, manageFilters } from '@app/services';
import { IActiveFilter } from '@app/models';

class WorkflowRequestService {
    readonly apiBase: string = '/api/directory/WorkflowCreationRequests';

    getWorkflowRequests(orderBy: string, asc: string, top: number, skip: number, organizationId: string, isReset: boolean, filters?: IActiveFilter[]): AxiosPromise {
        return apiService.get(`${this.apiBase}/GetDetailedRequests`, {
            params: {
                $orderBy: orderBy + ' ' + asc,
                $top: top,
                $skip: skip,
                $count: isReset,
                ...(filters ? { $filter: manageFilters(filters, organizationId) } : { $filter: manageFilters([], organizationId) })
            }
        })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    deleteWorkflowRequest(jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}/DeleteRequests`;

        return apiService.post(apiUrl,
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    uploadWorkflowRequest(fileData: object, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = '/api/import/samlx';

        return apiService.post(apiUrl,
            fileData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
             onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    workflowCreationRequests(id: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}(${id})`;

        return apiService.get(apiUrl,
            { onError: handleError, onSuccess: handleSuccess
        })
            .catch();
    }

    createRequestApplication(jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}/CreateRequestApplication`;

        return apiService.post(apiUrl,
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    updateWorkflowRequest(id: string, jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}(${id})`;

        return apiService.put(apiUrl, jsonObject,
            {
                onError: handleError, onSuccess: handleSuccess
            })
            .catch();
    }

    deleteTestApplication(id: string, handleError: Function, handleSuccess?: Function): AxiosPromise {
        const apiUrl: string = `/api/directory/Applications(${id})`;

        if (handleSuccess) {
            return apiService.delete(apiUrl,
                {
                    onError: handleError, onSuccess: handleSuccess
                })
                .catch();
        }
        else {
            return apiService.delete(apiUrl,
                {
                    onError: handleError
                })
                .catch();
        }
    }
}

export const workflowRequestService = new WorkflowRequestService();